import { useState } from "react"
import React from "react"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Input from "components/ProjectNonSpecificComponents/Elements/Input"
import { useTranslation } from "react-i18next"
import HorizontalFormField from "../HorizontalFormField"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import Checkbox from "components/ProjectSpecificComponents/Elements/Global/atoms/Checkbox"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { observer } from "mobx-react"
import { isToolType } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import Select from "components/ProjectSpecificComponents/Elements/Global/atoms/Select"
import { isReactSelectSingleOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import { HEIGHT_WITH_NAV_AND_FOOTER } from "components/ProjectSpecificComponents/Constants/GLOBAL_CONSTANTS"
import { useForm } from "react-hook-form"

interface Props {
	submitButton: JSX.Element
}

export const ConnectionForm = observer(({ submitButton }: Props) => {
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { isMobile } = useScreenType()
	const [showPassword, setShowPassword] = useState<boolean>(false)

	const { handleSubmit } = useForm()
	const onSubmit = handleSubmit((data: any) => {})

	return (
		// Form is used to hide autocomplete, onSubmit for preventing params showing in url
		<form autoComplete="off" onSubmit={onSubmit}>
			<HyperDiv direction="column" spaceBetweenElems="2.25rem">
				<HorizontalFormField
					containerStyle={{ padding: isMobile ? "8px 16px" : 0 }}
					label={t("forms.field-label.tool")}
					tooltip={t(`forms.tooltip.field-description.tool`)}
					tooltipBelowInputField
				>
					<Select
						options={[{ label: "Jama", value: "jama" }]}
						valueKey={formStore.settingsData.connection.tool}
						onChange={(selectedOption) => {
							if (isReactSelectSingleOption(selectedOption)) {
								if (!isToolType(selectedOption.value)) return
								formStore.mergeConnectionFormData({ tool: selectedOption.value })
							} else {
								formStore.mergeConnectionFormData({ tool: undefined })
							}
						}}
					/>
				</HorizontalFormField>

				<HorizontalFormField
					containerStyle={{ padding: isMobile ? "8px 16px" : 0 }}
					label={t("forms.field-label.url")}
					tooltip={t(`forms.tooltip.field-description.url`)}
					tooltipBelowInputField
				>
					<Input
						name="url"
						wide
						value={formStore.settingsData.connection.url}
						onChange={(e) => formStore.mergeConnectionFormData({ url: e.target.value })}
					/>
				</HorizontalFormField>

				<HorizontalFormField
					containerStyle={{ padding: isMobile ? "8px 16px" : 0 }}
					label={t("forms.field-label.username")}
					tooltip={t(`forms.tooltip.field-description.username`)}
					tooltipBelowInputField
				>
					<Input
						name="userName"
						wide
						value={formStore.settingsData.connection.userName}
						onChange={(e) => formStore.mergeConnectionFormData({ userName: e.target.value })}
					/>
				</HorizontalFormField>

				<HorizontalFormField
					containerStyle={{ padding: isMobile ? "8px 16px" : 0 }}
					label={t("forms.field-label.password")}
					tooltip={t(`forms.tooltip.field-description.password`)}
					tooltipBelowInputField
				>
					<Input
						name="password"
						wide
						autoComplete="new-password"
						type={showPassword ? "text" : "password"}
						value={formStore.settingsData.connection?.password ?? ""}
						onChange={(e) => formStore.mergeConnectionFormData({ password: e.target.value })}
						placeholder="********"
					/>
				</HorizontalFormField>

				<HorizontalFormField
					containerStyle={{ padding: isMobile ? "8px 16px" : 0 }}
					label=""
					tooltipBelowInputField
				>
					<HyperDiv direction="row" centeredY>
						<Checkbox checked={showPassword} onCheck={setShowPassword} />
						<Whitespace h x={isMobile ? ".5" : "1.25"} />
						{t("forms.field-label.show-password")}
					</HyperDiv>
				</HorizontalFormField>
				<HyperDiv direction="row" centeredY spacedAround>
				    <HyperDiv >{submitButton}</HyperDiv>
				</HyperDiv>
			</HyperDiv>
		</form>
	)
})

export default ConnectionForm
